import React from 'react';
import { type FootnoteData } from '../../../dm/bible-types.js';
import { type BibleViewOptions } from '@soulhx/fs-common';
import { BibleContentItem } from './BibleContentItem.js';

interface IRenderFootnote {
  fn: FootnoteData;
  options: BibleViewOptions;
}
export const RenderFootnote = ({ fn, options }: IRenderFootnote) => {
  return (
    <div className="footnote-block">
      <BibleContentItem
        item={{
          type: 'tag',
          name: 'fnID',
          attrs: { style: 'fnID' },
          items: [{ type: 'text', text: `[${fn.fnIdentifier}]` }],
        }}
        options={options}
      />
      <BibleContentItem item={fn.fn} filterStyle="fr" options={options} />
    </div>
  );
};
